export enum EcigTourKeys {
    ACETALDEHYDE_COMPLETE = "TourACETALEHYDE_COMPLETE",
    CADMIUM_COMPLETE = "TourCADMIUM_COMPLETE",
    LEAD_COMPLETE = "TourLEAD_COMPLETE",
    NICOTINE_COMPLETE = "TourNICOTINE_COMPLETE",
    PROPYLENE_GLYCOL_COMPLETE = "TourPROPYLENE_GLYCOL_COMPLETE",
}

export class EcigTourRepo {
    private static innerInstance: EcigTourRepo
    private ecigCompletedStages: Array<EcigTourKeys> = []

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    setStageComplete(stage: EcigTourKeys) {
        this.ecigCompletedStages.push(stage)
    }

    isAcetaldehydeComplete(): boolean {
        return this.ecigCompletedStages.includes(
            EcigTourKeys.ACETALDEHYDE_COMPLETE,
        )
    }

    setAcetaldehydeAsComplete() {
        this.ecigCompletedStages.push(EcigTourKeys.ACETALDEHYDE_COMPLETE)
    }

    isCadmiumComplete(): boolean {
        return this.ecigCompletedStages.includes(EcigTourKeys.CADMIUM_COMPLETE)
    }

    setCadmiumAsComplete() {
        this.ecigCompletedStages.push(EcigTourKeys.CADMIUM_COMPLETE)
    }

    isLeadComplete(): boolean {
        return this.ecigCompletedStages.includes(EcigTourKeys.LEAD_COMPLETE)
    }

    setLeadAsComplete() {
        this.ecigCompletedStages.push(EcigTourKeys.LEAD_COMPLETE)
    }

    isNicotineComplete(): boolean {
        return this.ecigCompletedStages.includes(EcigTourKeys.NICOTINE_COMPLETE)
    }

    setNicotineAsComplete() {
        this.ecigCompletedStages.push(EcigTourKeys.NICOTINE_COMPLETE)
    }

    isPropyleneGlycolComplete(): boolean {
        return this.ecigCompletedStages.includes(
            EcigTourKeys.PROPYLENE_GLYCOL_COMPLETE,
        )
    }

    setPropyleneGlycolAsComplete() {
        this.ecigCompletedStages.push(EcigTourKeys.PROPYLENE_GLYCOL_COMPLETE)
    }
}
